import { IGroupDto } from "moo-shared";
import { ITile } from "./tile.model";


export class GroupTile implements ITile {
  constructor(
    public key: string,
    public name: string,
    public picture: string = "",
    public defaultImage: string = "./assets/images/icon_group.svg",
    public defaultImageClass: string = "blue-background") { }

  static fromDto(value: IGroupDto) {
    return new GroupTile(value.Key, value.Name!);
  }
}